// extracted by mini-css-extract-plugin
export default {"esim_dialog":"EsimPaymentSuccess_esim_dialog__2lPmu","customer_service_text":"EsimPaymentSuccess_customer_service_text__O93ZB"};